export default __webpack_public_path__ + "static/media/marke_4.a9b0dbc1.png";